import React from "react";
import { AplicativosCard } from "./AplicativosCard";
import {
  faCalendarAlt as faCalendarAltRegular,
  faIdCard as faIdCardRegular,
} from "@fortawesome/free-regular-svg-icons";
import { RemediosIcon } from "components/icons/RemediosIcon";

export const AplicativosCards = () => {
  return (
    <section className="container-fluid bg-blue">
      <h1
        className="font-weight-bold text-center py-4 text-white"
        style={{ fontSize: "2em", margin: "0 auto", maxWidth: "100%" }}
      >
        Quais são as Vantagens do Aplicativo Paciente ProntLife?
      </h1>
      <div className="container aplicativos-page__cards-container">
        <div className="row row-cols-1 row-cols-md-3">
          <div className="col aplicativos-page__column-card">
            <AplicativosCard
              icon={faCalendarAltRegular}
              titleCard={"Agendamento online"}
              textCard={
                "Agendamento rápido e fácil: procure por especialidades médicas e  horários disponíveis próximos de você"
              }
            />
          </div>

          <div className="col aplicativos-page__column-card">
            <AplicativosCard
              icon={faIdCardRegular}
              titleCard={"Carteirinha Online"}
              textCard={
                "Tenha acesso à sua carteirinha de saúde em qualquer lugar"
              }
            />
          </div>
          <div className="col aplicativos-page__column-card">
            <AplicativosCard
              customIcon={
                <RemediosIcon
                  size={"5em"}
                  className="aplicativos-page__card-icon"
                />
              }
              titleCard={"Medicamentos"}
              textCard={"Acesse suas prescrições e orientações de saúde"}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
